import Layout from '../../internal/Layout.vue'
import AlertPage from './alert/Alert.vue'

const AlertRoutes = {
  component: Layout,
  children: [
    {
      name: 'alert',
      path: '/',
      component: AlertPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default AlertRoutes
